import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-info',
  templateUrl: './icon-info.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconInfoComponent {}
